import React, { Component } from 'react';
import './checkbox.css';

class CheckboxControl extends Component {
	render() {
		const { props } = this,
			{
				id = '',
				text = '',
				checked = false,
				disabled = false,
				className = '',
				onClick = () => { },
				validateMassage = ''
			} = props;

		return (
			<div className={`checkbox${className ? ` ${className}` : ''}`} key={id}
				onClick={() => {
					if (!disabled) onClick();
				}}>
				<div className='checkbox-label'>
					<img className={validateMassage ? 'checkbox-error' : ''} style={disabled ? { opacity: '0.6' } : {}} alt=''
						src={require(`assets/images/checkbox-${checked ? 'checked.svg' : 'default.svg'}`)} />
					<span>{text}</span>
				</div>
				{
					validateMassage ? (
						<div className='checkbox-error-text'>{validateMassage}</div>
					) : null
				}
			</div>
		);
	}
}

export default CheckboxControl;